import BaseAuthenticator from 'ember-simple-auth/authenticators/base';
import EphemeralStore from 'ember-simple-auth/session-stores/ephemeral';
import { getOwner } from '@ember/owner';
import { readPreviewClaim } from 'tio-employee/utils/preview-handoff';
import { tokenRejectionReason } from 'tio-employee/utils/token-check';
import type SessionService from 'tio-employee/services/session';

/** Seats a landing-preview grant (RFC 128) for this page load only: a reload boots signed out and the host relaunches. */
export default class Preview extends BaseAuthenticator {
  async restore(): Promise<never> {
    throw new Error('A landing-preview grant is never restored');
  }

  /**
   * @throws when the token carries no read-only preview claim, when the live session
   *   store is not in-memory (a grant must never be persisted), or when the API refuses it
   */
  async authenticate({ access_token }: { access_token: string }) {
    if (!readPreviewClaim(access_token)) {
      throw new Error('Could not start preview: not a landing-preview grant');
    }

    const owner = getOwner(this);
    const store = (owner?.lookup('session:main') as { store?: unknown } | undefined)?.store;
    if (!(store instanceof EphemeralStore)) {
      throw new Error('Could not start preview: the session store would persist the grant');
    }

    const session = owner?.lookup('service:session') as SessionService | undefined;
    const reason = await tokenRejectionReason(access_token, session?.publicKey);
    if (reason) {
      throw new Error(`Could not start preview: ${reason}`);
    }

    return { access_token };
  }
}
